module.exports = __webpack_public_path__ + "img/tk.b75bd467.svg";